if (!customElements.get('learn-more')) {
  customElements.define(
    'learn-more',
    class LearnMore extends HTMLElement {
      constructor() {
        super();
        this.learnMoreButton = this.querySelector('button');
        this.scrollToDiv = document.querySelector('.section-02-pdp-product-additional-info');
      }

      connectedCallback() {
        if (!this.scrollToDiv || !this.learnMoreButton) return;
        this.learnMoreButton.addEventListener('click', () => {
          window.dispatchEvent(new Event('triggeredScrollStart'));
          if (typeof lenis !== 'undefined') {
            lenis.scrollTo(this.scrollToDiv, { onComplete: () => window.dispatchEvent(new Event('triggeredScrollEnd')) });
          } else {
            this.scrollToDiv.scrollIntoView({ block: 'center', behavior: 'instant' });
            window.dispatchEvent(new Event('triggeredScrollEnd'));
          }
        });
      }
    }
  );
}
